<template>
  <div>
    <div class="section-box">
      <el-form
        ref="form"
        label-width="auto"
        label-position="right"
        label-suffix="："
        :model="dioForm"
        :rules="rules"
        v-loading="loading"
      >
    <!-- 区分六种情况 useFuncType-->
    <!-- zigbee -->
    <template v-if="useFuncType === 1 || useFuncType === 2">
      <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.extPanId"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['extPanIdCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['extPanIdCurrent'] &&
                dioForm['extPanIdCurrent'].change
            "
            >{{ dioForm['extPanIdCurrent'].current + '-->' }}
          </span>
          <span v-if="dioForm['extPanIdCurrent']" style="color: red">{{
            dioForm['extPanIdCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item :label="$t('Join Attemp')" prop="channelPage">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.channelPage"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['channelPageCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['channelPageCurrent'] &&
                dioForm['channelPageCurrent'].change
            "
            >{{ dioForm['channelPageCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['channelPageCurrent']" style="color: red">{{
            dioForm['channelPageCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item :label="$t('device.transmit_power')" prop="transmitPower">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.transmitPower"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['transmitPowerCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['transmitPowerCurrent'] &&
                dioForm['transmitPowerCurrent'].change
            "
            >{{ dioForm['transmitPowerCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['transmitPowerCurrent']" style="color: red">{{
            dioForm['transmitPowerCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.channelMask"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['channelMaskCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['channelMaskCurrent'] &&
                dioForm['channelMaskCurrent'].change
            "
            >{{ dioForm['channelMaskCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['channelMaskCurrent']" style="color: red">{{
            dioForm['channelMaskCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.inNetInterval"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['inNetIntervalCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['inNetIntervalCurrent'] &&
                dioForm['inNetIntervalCurrent'].change
            "
            >{{ dioForm['inNetIntervalCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['inNetIntervalCurrent']" style="color: red">{{
            dioForm['inNetIntervalCurrent'].modify
          }}</span>
        </template>
        <template v-else>
          ---
        </template>
      </el-form-item>
    </template>
    <!-- lora -->
    <template v-else-if="useFuncType === 3 || useFuncType === 4">
      <el-form-item :label="$t('DevEUI')" prop="devEui">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.devEui"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else>
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['devEuiCurrent'] &&
                dioForm['devEuiCurrent'].change
            "
            >{{ dioForm['devEuiCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['devEuiCurrent']" style="color: red">{{
            dioForm['devEuiCurrent'].modify
          }}</span>
        </template>
      </el-form-item>
      <el-form-item :label="$t('AppEUI')" prop="appEui">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.appEui"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['appEuiCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['appEuiCurrent'] &&
                dioForm['appEuiCurrent'].change
            "
            >{{ dioForm['appEuiCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['appEuiCurrent']" style="color: red">{{
            dioForm['appEuiCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item :label="$t('AppKey')" prop="appKey">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.appKey"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['appKeyCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['appKeyCurrent'] &&
                dioForm['appKeyCurrent'].change
            "
            >{{ dioForm['appKeyCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['appKeyCurrent']" style="color: red">{{
            dioForm['appKeyCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.channelMask"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['channelMaskCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['channelMaskCurrent'] &&
                dioForm['channelMaskCurrent'].change
            "
            >{{ dioForm['channelMaskCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['channelMaskCurrent']" style="color: red">{{
            dioForm['channelMaskCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
      <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.inNetInterval"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['inNetIntervalCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['inNetIntervalCurrent'] &&
                dioForm['inNetIntervalCurrent'].change
            "
            >{{ dioForm['inNetIntervalCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['inNetIntervalCurrent']" style="color: red">{{
            dioForm['inNetIntervalCurrent'].modify
          }}</span>
        </template>
        <template>---</template>
      </el-form-item>
    </template>
    <!-- zeta -->
    <template v-else>
      <el-form-item :label="$t('device.in_net_interval')" prop="inNetInterval">
        <el-input
          v-if="!isClickConfig"
          v-model.trim="dioForm.inNetInterval"
          style="width: 250px"
          maxlength="50"
          :placeholder="$t('public.please_enter')"
        />
        <template v-else-if="dioForm['inNetIntervalCurrent']">
          <span
            v-if="
              rowData['configStatus'] !== 2 &&
                dioForm['inNetIntervalCurrent'] &&
                dioForm['inNetIntervalCurrent'].change
            "
            >{{ dioForm['inNetIntervalCurrent'].current + '-->' }}</span
          >
          <span v-if="dioForm['inNetIntervalCurrent']" style="color: red">{{
            dioForm['inNetIntervalCurrent'].modify
          }}</span>
        </template>
        <template v-else>---</template>
      </el-form-item>
    </template>
      </el-form>
      <div class="form-actions" v-show="rowData['config_status'] !== 1">
        <el-button v-if="isClickConfig" type="primary" @click="configISFn">{{
          $t('public.config')
        }}</el-button>
        <template v-else>
          <el-button type="primary" @click="cancelFn">{{
            $t('public.cancel')
          }}</el-button>
          <el-button type="primary" @click="configSave">{{
            $t('public.save')
          }}</el-button>
        </template>
      </div>
    </div>
    <!-- 第三部分: Command -->
    <div class="section-box" v-if="cmd">
      <el-form label-width="100px" label-position="right" label-suffix="：">
        <el-form-item :label="$t('public.command')">
          <span class="cmd-text">{{ cmd }}</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  sensorGetDetailConfig,
  sensorUpdateNetConfig
} from '@/api/modules/sensor.js'
import addRules from '@/pages/equipment/validate/addRules.js'

export default {
  props: ['useFuncType', 'rowData'],
  computed: {
    // 正则不会写啊  难搞
    rules () {
      const rules = addRules.call(this, 'rule', [
        'extPanId',
        'channelPage',
        'channelMask',
        'transmitPower',
        'inNetInterval',
        'devEui',
        'appEui',
        'appKey'
      ])
      return rules
    }
  },
  data () {
    return {
      dioForm: {},
      isClickConfig: true,
      cmd: '',
      listArray: [],
      loading: false
    }
  },
  activated () {
    this.httpUrlFn()
  },
  methods: {
    httpUrlFn () {
      sensorGetDetailConfig(
        {
          sensorId: this.rowData.id,
          tagId: this.rowData.tagId
        },
        'net'
      )
        .then(({ result }) => {
          if (result.sensorConfig) {
            if (result.sensorConfig.content) {
              const JsonContent = JSON.parse(result.sensorConfig.content)
              this.cmd = JsonContent.cmd
              console.log('JsonContent==>', JsonContent)
              if (this.useFuncType === 1 || this.useFuncType === 2) {
                this.dioForm = {
                  extPanId: JsonContent.item.ext_pan_id.modify,
                  extPanIdCurrent: JsonContent.item.ext_pan_id,

                  channelPage: JsonContent.item.channel_page.modify,
                  channelPageCurrent: JsonContent.item.channel_page,

                  transmitPower: JsonContent.item.transmit_power.modify,
                  transmitPowerCurrent: JsonContent.item.transmit_power,

                  channelMask: JsonContent.item.channel_mask.modify,
                  channelMaskCurrent: JsonContent.item.channel_mask,

                  inNetInterval: JsonContent.item.in_net_interval.modify,
                  inNetIntervalCurrent: JsonContent.item.in_net_interval
                }
              } else if (this.useFuncType === 3 || this.useFuncType === 4) {
                this.dioForm = {
                  devEui: JsonContent.item.dev_eui.modify,
                  devEuiCurrent: JsonContent.item.dev_eui,

                  appEui: JsonContent.item.app_eui.modify,
                  appEuiCurrent: JsonContent.item.app_eui,

                  appKey: JsonContent.item.app_key.modify,
                  appKeyCurrent: JsonContent.item.app_key,

                  channelMask: JsonContent.item.channel_mask.modify,
                  channelMaskCurrent: JsonContent.item.channel_mask,

                  inNetInterval: JsonContent.item.in_net_interval.modify,
                  inNetIntervalCurrent: JsonContent.item.in_net_interval
                }
              } else {
                this.dioForm = {
                  inNetInterval: JsonContent.item.in_net_interval.modify,
                  inNetIntervalCurrent: JsonContent.item.in_net_interval
                }
              }
            }
            this.$emit(
              'listFn',
              result.sensorConfig.responseDeviceConfigLogList
            )
          } else {
            // 默认值
            if (this.useFuncType === 1 || this.useFuncType === 2) {
              this.dioForm = {
                extPanId: '50414e4944303032',
                extPanIdCurrent: {
                  modify: '50414e4944303032'
                },

                channelPage: '0',
                channelPageCurrent: {
                  modify: '0'
                },

                transmitPower: '10',
                transmitPowerCurrent: {
                  modify: '10'
                },

                channelMask: '11',
                channelMaskCurrent: {
                  modify: '11'
                },

                inNetInterval: '900',
                inNetIntervalCurrent: {
                  modify: '900'
                }
              }
            } else if (this.useFuncType === 3 || this.useFuncType === 4) {
              this.dioForm = {
                devEui: '120',
                devEuiCurrent: {
                  modify: '120'
                },

                appEui: '564D2D4555493031',
                appEuiCurrent: {
                  modify: '564D2D4555493031'
                },

                appKey: '00000000000000000000000000000000',
                appKeyCurrent: {
                  modify: '00000000000000000000000000000000'
                },

                channelMask: '11',
                channelMaskCurrent: {
                  modify: '11'
                },

                inNetInterval: '900',
                inNetIntervalCurrent: {
                  modify: '900'
                }
              }
            } else {
              this.dioForm = {
                inNetInterval: '900',
                inNetIntervalCurrent: {
                  modify: '900'
                }
              }
            }
          }
        })
        .catch(() => {
          // 默认值
          this.dioForm = {}
        })
    },
    configISFn () {
      this.isClickConfig = !this.isClickConfig
    },

    cancelFn () {
      this.isClickConfig = true
      this.clearValidate()
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async configSave () {
      const flag = await this.justify()
      if (!flag) return
      this.loading = true
      const query = {
        idList: [this.rowData.id],
        type: this.useFuncType
      }
      for (const key in this.dioForm) {
        if (key.indexOf('Current') === -1) {
          query[key] = this.dioForm[key]
        }
      }
      sensorUpdateNetConfig(query)
        .then(({ result, state }) => {
          if (result && state.code === 200) {
            setTimeout(() => {
              this.$message.success($t('integration.update_successful'))
              this.isClickConfig = !this.isClickConfig
              this.httpUrlFn()
            }, 500)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.section-box {
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-left: 3px solid var(--primary-color, #409eff);
  border-radius: 4px;
  padding: 14px 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.form-actions {
  text-align: right;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e4e7ed;
}
.cmd-text {
  word-break: break-all;
  font-family: Consolas, Monaco, monospace;
  color: #303133;
}
</style>
